const errores = [
  {
    mensaje:
      "ya completaste el formulario y tenemos tus datos. Si todavía no cobrás tu jubilación en BBVA, recordá que para continuar el proceso tenés que hacer el cambio de banco en ANSES.",
    codigo: "01"
  },
  {
    mensaje:
      "lamentablemente se agotó el stock para participar por el regalo de bienvenida. Igualmente podés traer tu jubilación a BBVA y disfrutar de beneficios exclusivos.",
    codigo: "02"
  },
  {
    mensaje: "En este momento no tenemos ningún producto para ofrecerte.",
    codigo: "03"
  },
  {
    mensaje:
      'algo salió mal<p class="titulo">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
    codigo: "04"
  }
];

export default errores;
